import { classNames } from "@op/opds.opux"
import React from "react"
import { ReactComponent } from "../svgs/illustration-insurance-category-animals.svg"

const IconCategoryAnimals = ({ className, ...props }) => (
  <ReactComponent aria-hidden={true} {...props} className={classNames("insurance-icon", className)} />
)

IconCategoryAnimals.displayName = "IconCategoryAnimals"
export default IconCategoryAnimals
